import { useTranslation } from "react-i18next"
import React, {useState, useEffect} from 'react'
import { Button, Col, FloatingLabel, Form, Modal, Row, Spinner } from "react-bootstrap"
import { useNavigate } from "react-router"
import { getFindocTypes, getIncoterm, getSalesArea, getTOP } from "src/api/modules/getdatalist"
import i18next from "i18next"
import { createFindoc } from "src/api/modules/findoc"
import { InputFile } from "src/app/components/InputFile"
import { Link } from "react-router-dom"
import swal from 'sweetalert'

const DistributorCreate: React.FC = () => {
    const {t} = useTranslation()

    const [btnLoading, setBtnLoading] = useState(false)
    const [showApprove, setShowApprove] = useState(false)
    const [dataProdusen, setDataProdusen] = useState<any[]>([])
    const [incoterm, setIncoterm] = useState<any[]>([])
    const [findocType, setFindocType] = useState('')
    const [TOP, setTOP] = useState<any[]>([])
    const [selectProducen, setSelectProduces] = useState('')
    const [skbn, setSKBN] = useState('')
    const [noFindoc, setNoFindoc] = useState('')
    const [tanggalFindoc, setTanggalFindoc] = useState('')
    const [sektor, setSektor] = useState('')
    const [currency, setCurrency] = useState('')
    const [files, setFiles] = useState({file: null})
    const [custCode, setCustCode] = useState('')
    const [keterangan, setKeterangan] = useState('')
    const [findocDesc, setFindocDesc] = useState('')
    const [noSkpp, setNoSkpp] = useState('')
    const navigate = useNavigate()
    const [showComment, setShowComment] = useState(false)
    const [comment, setComment] = useState([])
    const [tempComment, setTempComment] = useState('')
    const [findocTypes, setFindocTypes] = useState<any[]>([])
    const [loadingFindocTypes, setLoadingFindocTypes] = useState(false);

    const getAllData = async () => {
        await getSalesArea(localStorage.getItem('cust-code')).then((res: any) => {
        setDataProdusen(res.data.data)
        })
        await getIncoterm().then((res: any) => {
        setIncoterm(res.data.data)
        })
    }

  useEffect(() => {
    const loadFindocTypes = async () => {
      setLoadingFindocTypes(true)
      await getFindocTypes(sektor).then((res: any) => {
        setFindocTypes(res.data.data)
      })
      setLoadingFindocTypes(false)
    }

    loadFindocTypes();
  }, [sektor]);

  const create = async () => {
    setBtnLoading(true)
    let file = files.file
    let formdata = new FormData()

    formdata.append('file', file!)
    formdata.append('sales_org_code', selectProducen!)
    formdata.append('findoc_type', findocType!)
    if (findocType == 'skbdn') formdata.append('type_skbdn', skbn!)

    formdata.append('tgl_findoc', tanggalFindoc!)
    formdata.append('findoc_desc', findocDesc)
    formdata.append('sector_id', sektor)
    formdata.append('description', keterangan!)
    formdata.append('credentials', localStorage.getItem('credential')!)
    formdata.append('no_skpp', noSkpp)
    formdata.append('lang', i18next.language)
    formdata.append('num_findoc', noFindoc!)
    if (comment.length < 1) formdata.append('comment', '[]')
    else formdata.append('comment', JSON.stringify(comment))

    await createFindoc(formdata)
      .then((response: any) => {
        if (!response.data.error)
          swal({
            title: `${t('Findoc Created Successfully')}`,
            icon: 'success',
          }).then(() => {
            navigate('/financial')
          })
        else
          swal({
            title: `${t('Error')}`,
            icon: 'error',
          })
      })
      .catch(function (error: any) {
        if (error.response) {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  useEffect(() => {
    getAllData()
    const temp = JSON.parse(localStorage.getItem('credential-decoded')!)
    setCustCode(temp?.customer_code)
  }, [])

  useEffect(() => {
    const top = async () => {
      await getTOP().then((res: any) => {
        setTOP(res.data.data)
      })
    }

    top()
  }, [custCode])

  const [datenow, setDateNow] = useState('')

  useEffect(() => {
    let today = new Date()
    let dd = String(today.getDate()).padStart(2, '0')
    let mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    let yyyy = today.getFullYear()
    let hh = String(today.getHours()).padStart(2, '0')
    let mmm = String(today.getMinutes()).padStart(2, '0')
    let ss = String(today.getSeconds()).padStart(2, '0')
    setDateNow(dd + '-' + mm + '-' + yyyy + " " + [
      hh, mmm, ss
    ].join(":"))
  }, [])

  const handleComment = () => {
    if (tempComment != '') {
      let tempcomm: any = [...comment]
      tempcomm.push(tempComment)
      setComment(tempcomm)

      const areacomment = document.getElementById('areacomment') as HTMLInputElement
      if (areacomment != null) areacomment.value = ''
    }
  }

    return (
        <div className='card'>
            <div className='card-body mt-5'>
            <form action=''>
                <Row>
                <Col md={6}>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>
                        Sales Org<span className='text-danger'>*</span>
                    </Form.Label>
                    <Form.Select
                        aria-label='Default select example'
                        style={{width: '70%'}}
                        onChange={(e: any) => setSelectProduces(e.target.value)}
                    >
                        <option selected value={''}>
                        {t('pilih')} Sales Org
                        </option>
                        {dataProdusen.map((item: any, index: number) => {
                        return (
                            <option key={item?.sales_org ?? index} value={item.sales_org}>
                            {item.produsen?.name}
                            </option>
                        )
                        })}
                    </Form.Select>
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>
                        {t('Findoc Type')}
                        <span className='text-danger'>*</span>
                    </Form.Label>
                    <Form.Select
                        aria-label='Default select example'
                        style={{width: '70%'}}
                        disabled={ !sektor || loadingFindocTypes }
                        onChange={(e: any) => {
                        setFindocType(e.target.value)
                        if (e.target.value == 'lc') setCurrency('USD')
                        }}
                    >
                        <option selected value={''}>
                        {t('pilih')} {t('Findoc Type')}
                        </option>
                        {findocTypes.map((item: any, index: number) => {
                        return (
                            <option key={item?.code ?? index} value={item.code}>
                            {item?.name}
                            </option>
                        )
                        })}
                    </Form.Select>
                    </div>
                    {findocType == 'skbdn' ? (
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                        <Form.Label className='me-2'>
                        {t('Skbdn Type')}
                        <span className='text-danger'>*</span>
                        </Form.Label>
                        <Form.Select
                        aria-label='Default select example'
                        style={{width: '70%'}}
                        onChange={(e: any) => setSKBN(e.target.value)}
                        >
                        <option selected value={''}>
                            {t('pilih')} {t('Skbdn Type')}
                        </option>
                        <option value='1'>At Sight</option>
                        <option value='2'>Usance</option>
                        </Form.Select>
                    </div>
                    ) : (
                    <></>
                    )}
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>
                        {t('Ext Findoc Number')}
                        <span className='text-danger'>*</span>
                    </Form.Label>
                    <Form.Control
                        type='text'
                        placeholder={t('Ext Findoc Number')}
                        style={{width: '70%'}}
                        onChange={(e: any) => setNoFindoc(e.target.value)}
                    />
                    </div>

                    <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>
                        {t('Findoc Desc')}
                        <span className='text-danger'>*</span>
                    </Form.Label>
                    <Form.Control
                        type='text'
                        placeholder={t('Enter Findoc Desc')}
                        style={{width: '70%'}}
                        onChange={(e: any) => setFindocDesc(e.target.value)}
                    />
                    </div>
                </Col>

                <Col md={6}>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>
                        {t('sub-order-sektor')}
                        <span className='text-danger'>*</span>
                    </Form.Label>
                    <Form.Select
                        aria-label='Default select example'
                        id='sektor'
                        style={{width: '70%'}}
                        onChange={(e: any) => setSektor(e.target.value)}
                    >
                        <option hidden value=''>
                        {t('Pilih-sector')}{' '}
                        </option>
                        <option value='1'>{t('Domestik Korperasi')} </option>
                        <option value='2'>{t('Domestik Retail')} </option>
                        <option value='3'>{t('Export')} </option>
                    </Form.Select>
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>
                        {t('Tanggal Findoc')}
                        <span className='text-danger'>*</span>
                    </Form.Label>
                    <Form.Control
                        type='date'
                        style={{width: '70%'}}
                        onChange={(e: any) => setTanggalFindoc(e.target.value)}
                    />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4 w-100'>
                    <Form.Label className='' style={{width: '30%'}}>
                        {t('no skkp/lecto')}
                    </Form.Label>
                    <Form.Control
                        type='text'
                        placeholder={t('nomor') + ' ' + 'SKPP/Letco/SO'}
                        style={{width: '70%'}}
                        onChange={(e: any) => setNoSkpp(e.target.value)}
                    />
                    </div>
                    <div className='d-flex justify-content-between align-items-center mb-4'>
                    <Form.Label className='me-2'>{t('Keterangan')}</Form.Label>
                    <Form.Control
                        as='textarea'
                        placeholder={t('Keterangan')}
                        style={{width: '70%'}}
                        onChange={(e: any) => setKeterangan(e.target.value)}
                    />
                    </div>
                </Col>
                </Row>
                <div className='my-3 '>
                <div className='d-flex'>
                    <Form.Label>
                    {t('upload')} Findoc<span className='text-danger'>*</span>
                    </Form.Label>
                </div>
                <InputFile
                    setFileName={(_: string) => {}}
                    setFiles={setFiles}
                    isBase64={false}
                />
                </div>
                <div className='d-flex justify-content-end my-5'>
                <Link to={'/financial'}>
                    <div className='btn btn-secondary me-1'>{t('sip-batal')}</div>
                </Link>
                <Button className='btn btn-info me-1' onClick={() => setShowComment(true)}>
                    {t('Comment')}
                </Button>
                <Button className='btn btn-primary' onClick={() => setShowApprove(true)}>
                    {t('order-kirim')}
                </Button>
                </div>
            </form>
            </div>

            <Modal
            show={showComment}
            onHide={() => setShowComment(false)}
            centered
            backdrop='static'
            size='lg'
            scrollable
            >
            <Modal.Header closeButton>
                <Modal.Title>{t('Comment')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FloatingLabel controlId='floatingTextarea2' label={t('Comment')}>
                <Form.Control
                    as='textarea'
                    id='areacomment'
                    placeholder={t('Tinggal-pesan')}
                    onChange={(e: any) => setTempComment(e.target.value)}
                    style={{height: '100px'}}
                />
                </FloatingLabel>
                <div className='d-flex justify-content-end mt-3 mb-3'>
                <Button variant='primary' onClick={() => handleComment()}>
                    {t('Submit')}
                </Button>
                </div>
                {comment.length < 1 ? (
                ''
                ) : (
                <div className='table-responsive mt-10 bdr'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                        <tr className='fw-bold w-100 align-items-center'>
                        <th className='td-3 text-center'>{t('no')}</th>
                        <th className='td-3 text-center'>{t('order-tanggal')}</th>
                        <th className='td-3 text-center'>{t('order-user')}</th>
                        <th className='td-3 text-center'>{t('Comment')}</th>
                        </tr>
                    </thead>
                    {comment.map((item: any, _index: number) => (
                        <tbody key={item?.id ?? _index}>
                        <tr className='w-100 align-items-center'>
                            <td className='td-150 text-center'>{_index + 1}</td>
                            <td className='td-150 text-center'>{datenow}</td>
                            <td className='td-150 text-center'>{localStorage.getItem('username')}</td>
                            <td className='td-60 text-center text-wrap'>
                            <div style={{whiteSpace: 'pre-line'}}>{item}</div>
                            </td>
                        </tr>
                        </tbody>
                    ))}
                    </table>
                    {/* End Table Head */}
                </div>
                )}
            </Modal.Body>
            </Modal>

            <Modal show={showApprove} onHide={() => setShowApprove(false)} centered backdrop='static'>
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <h3 className='text-center mb-5'>{t('apakahAndaYakin create Findoc')}</h3>
            </Modal.Body>
            <Modal.Footer>
                <Button className='btn btn-secondary' onClick={() => setShowApprove(false)}>
                {t('Tidak')}
                </Button>
                <Button className='btn btn-primary' onClick={create} disabled={btnLoading}>
                {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
                </Button>
            </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DistributorCreate;